function toFiniteNumber(value, fallback = 0) {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
}

export function clampConfidence(value, fallback = 0) {
  return Math.max(0, Math.min(1, toFiniteNumber(value, fallback)));
}

export function confidenceThresholdForTerm({ result, type, defaultThreshold = 0 }) {
  const byTypeThreshold = result?.thresholds?.byType?.[type];
  if (byTypeThreshold !== undefined && byTypeThreshold !== null) {
    return clampConfidence(byTypeThreshold, defaultThreshold);
  }
  const globalThreshold = result?.thresholds?.confidence;
  if (globalThreshold !== undefined && globalThreshold !== null) {
    return clampConfidence(globalThreshold, defaultThreshold);
  }
  return clampConfidence(defaultThreshold, 0);
}

export function visibilityForTerm(section, type, defaultVisible = true, visibilityKey = 'byTypeVisible') {
  const byTypeVisible = section?.[visibilityKey];
  if (byTypeVisible && Object.prototype.hasOwnProperty.call(byTypeVisible, type)) {
    return byTypeVisible[type] === true;
  }
  if (section?.visible !== undefined && section?.visible !== null) {
    return section.visible === true;
  }
  return defaultVisible;
}

export function visibilityByTerm(termTypes = [], section, defaultVisible = true, visibilityKey = 'byTypeVisible') {
  return termTypes.reduce((visibility, type) => ({
    ...visibility,
    [type]: visibilityForTerm(section, type, defaultVisible, visibilityKey)
  }), {});
}

export function activeTermHeatmapPoints({
  heatmap,
  normalizePointType = point => String(point?.type || '').toLowerCase()
}) {
  const visibleByType = heatmap?.byTypeVisible || {};
  return (heatmap?.points || []).filter(point => visibleByType[normalizePointType(point)]);
}

export function buildTermHeatmapLayers({
  termTypes = [],
  heatmap,
  gradients = {},
  zIndexByType = {},
  defaultZIndex = 2,
  idForType = type => `term-heatmap-${type}`,
  normalizePointType = point => String(point?.type || '').toLowerCase()
}) {
  const visibleByType = heatmap?.byTypeVisible || {};
  return termTypes
    .filter(type => visibleByType[type])
    .map(type => ({
      id: idForType(type),
      type,
      visible: true,
      opacity: heatmap?.opacity,
      radius: heatmap?.radius,
      blur: heatmap?.blur,
      zIndex: zIndexByType[type] ?? defaultZIndex,
      gradient: gradients[type],
      points: (heatmap?.points || []).filter(point => normalizePointType(point) === type)
    }))
    .filter(layer => layer.points.length);
}
